(function() {
    'use strict';

    angular.module('vhols')

        .filter('formatListDate', function() {
            var DATE_OUTPUT_FORMAT = 'MMM YYYY';

            return function(thisMoment) {
                return thisMoment.format(DATE_OUTPUT_FORMAT);
            };
        })

        .filter('dateFormatter', ['$interpolate', function($interpolate) {
            var DATE_FORMAT = 'DD MMM YYYY';
            var DATES_TEMPLATE = $interpolate('{{startDate}} - {{endDate}}');

            function getFormattedDate(thisMoment) {
                return thisMoment.format(DATE_FORMAT);
            }

            return function(price) {
                var res = getFormattedDate(price.startDate);

                if (price.notSameDate) {
                    res = DATES_TEMPLATE({
                        startDate: res,
                        endDate: getFormattedDate(price.endDate)
                    });
                }

                return res;
            };
        }])

        .filter('priceFormatter', ['$interpolate', '$sce', function($interpolate, $sce) {
            var PRICE_TEMPLATE = $interpolate('£{{price}} {{savingText}}');
            var SAVING_TEMPLATE = $interpolate('<div>Save £{{saving}}</div>');
            var NULL_PRICE_TEMPLATE = $interpolate('Call us on <a href="tel:{{telephone}}">{{telephone}}</a>');

            return function(price, telephone) {
                if (price.adultPrice) {
                    var savingText = '';

                    if (price.isOffer) {
                        savingText = SAVING_TEMPLATE({
                            saving: price.adultSaving
                        });
                    }

                    return $sce.trustAsHtml(PRICE_TEMPLATE({
                        price: price.adultPrice,
                        savingText: savingText
                    }));
                } else {
                    return $sce.trustAsHtml(NULL_PRICE_TEMPLATE({
                        telephone: telephone
                    }));
                }
            };
        }])

        .filter('numberRound', function() {
            return function(value) {
                if (!value) {
                    return '';
                }
                return Math.round(value);
            };
        });
})();
